import {getDocument, getWindow} from 'ssr-window';
import Config from 'config';

const window = getWindow();
const document = getDocument();

function loadGoogleAsync(cbString = 'loadGoogleCB') {
    /* eslint-disable */
    (function (d, s, id) {
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = element;
        js = d.createElement(s);
        js.id = id;
        js.src = `//apis.google.com/js/client:platform.js?onload=${cbString}`;
        fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'google-login');
    /* eslint-enable */
}

function onGoogleAuthInit(googleAuth) {
    // do something with googleAuth object
}

function onGoogleAuthError(error) {
    /* eslint-disable */
    if (error && error.details) {
        var message = error.details.toLowerCase();
        var isStorageMessage =
            message.indexOf('cookies') != -1 ||
            message.indexOf('storage') != -1;

        // Ignore error messages about cookies or storage not being enabled
        if (!isStorageMessage) {
            console.error(JSON.stringify(error));
        }
    } else {
        console.error('Google Auth Error');
    }
    /* eslint-enable */
}

function loadFacebookAsync() {
    /* eslint-disable */
    (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
            return;
        }
        js = d.createElement(s);
        js.id = id;
        js.async = true;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
    /* eslint-enable */
}

function facebookSetup(cb) {
    window.fbAsyncInit = () => {
        window.FB.init({
            appId: Config.facebookAppId,
            status: true, // check login status
            cookie: true, // enable cookies to allow the server to access the session
            xfbml: false,
            version: 'v2.8',
        });
        window.FB.AppEvents.logPageView();

        if (cb) {
            cb();
        }
    };
}

window.loadFacebookBackup = cb => {
    // Facebook SDK ready callback
    facebookSetup(cb);

    // Load the SDK Asynchronously
    loadFacebookAsync();
};

window.googleLoginBackupCB = null;

window.loadGoogleCB = () => {
    window.gapi.load('auth2', () => {
        if (!window.gapi.auth2.getAuthInstance()) {
            window.gapi.auth2
                .init({
                    client_id: Config.googleOAuth2Id, // eslint-disable-line camelcase
                })
                .then(onGoogleAuthInit, onGoogleAuthError);
        }
    });
};

window.loadGoogleBackupCB = () => {
    window.gapi.load('auth2', () => {
        if (!window.gapi.auth2.getAuthInstance()) {
            window.gapi.auth2
                .init({
                    client_id: Config.googleOAuth2Id, // eslint-disable-line camelcase
                })
                .then(onGoogleAuthInit, onGoogleAuthError);

            if (window.googleLoginBackupCB) {
                window.googleLoginBackupCB();
            }
        } else {
            if (window.googleLoginBackupCB) {
                window.googleLoginBackupCB();
            }
        }

        window.googleLoginBackupCB = null;
    });
};

window.loadGoogleBackup = cb => {
    window.googleLoginBackupCB = cb;

    loadGoogleAsync('loadGoogleBackupCB');
};

const loadThirdPartyScripts = () => {
    // GoogleTagManager
    /* eslint-disable */
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', Config.gtmAccount);
    /* eslint-enable */

    facebookSetup();
    loadFacebookAsync();
    loadGoogleAsync();
};

export default loadThirdPartyScripts;
